import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import RegsugarcaneForOcsb from "./RegsugarcaneForOcsb";
import RegsugarcaneForOcsbMaster from "./RegsugarcaneForOcsbMaster";

function CheckStatusTab() {
  return (
    <>
      <Tabs
        defaultActiveKey="farmer"
        id="uncontrolled-tab-example"
        className="mb-3"
      >
        <Tab eventKey="farmer" title="ชาวไร่อ้อย">
          <RegsugarcaneForOcsb />
        </Tab>
        <Tab eventKey="farmer-master" title="หัวหน้ากลุ่มชาวไร่อ้อย">
          <RegsugarcaneForOcsbMaster />
        </Tab>
      </Tabs>
    </>
  );
}

export default CheckStatusTab;
